import styled from 'styled-components';

const Container = styled.div`
  min-height: 100vh;
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor || theme.colors.base};
  min-width: 100vw;
  position: relative;
`;

export default Container;
